import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectConfig, selectReferral } from '../../redux/selectors';
import { Button, CheckCircle, Input } from 'common-ui-components';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import { setReferralAddress } from '../../redux/Slice/referralSlice';
import { NumericInput } from '../../components/NumericInput';
import { AlphanumericInput } from '../../components/AlphanumericInput';

const AddressValidation = () => {
  const { address } = useSelector(selectReferral);
  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm({ mode: 'onSubmit', shouldFocusError: false, defaultValues: address });
  const dispatch = useDispatch();
  const {
    language: {
      referral: { addressValidation: text },
    },
  } = useSelector(selectConfig);

  const onSubmit = (data) => {
    if (!address.hasCoverage) {
      dispatch(navigateTo('NoCoverageError'));
      return;
    }
    dispatch(setReferralAddress(data));
    dispatch(navigateTo('PersonalData'));
  };

  return (
    <section className='section addressValidation'>
      <h2 className='addressValidation-title'>{text.title}</h2>
      <span className='addressValidation-subtitle'>{text.subtitle}</span>
      <form className='addressValidation-form' onSubmit={handleSubmit(onSubmit)}>
        <div className='addressValidation-inputWrapper'>
          <Controller
            name='address'
            control={control}
            rules={{ required: { value: true, message: 'Obligatorio' } }}
            render={({ field: { name, onChange, ref, value } }) => (
              <Input
                id='address'
                name={name}
                onChange={onChange}
                ref={ref}
                value={value}
                disabled={true}
                typeInput='text'
                labelText={
                  <>
                    Dirección <span className='mandatory'>*</span>
                  </>
                }
                iconPosition='trailing-icon'
                status={value ? 'success' : 'default'}
                data-testid='address-input'
              >
                {value ? <CheckCircle size={21} /> : <></>}
              </Input>
            )}
          />
        </div>
        <div className='addressValidation-inputWrapper'>
          <Controller
            name='floor'
            defaultValue=''
            control={control}
            rules={{ required: { value: address.isBuilding, message: 'Obligatorio' } }}
            render={({ field: { name, onChange, ref, value, disabled } }) => (
              <NumericInput
                id='floor'
                name={name}
                onChange={onChange}
                ref={ref}
                value={value}
                disabled={disabled}
                typeInput='text'
                data-testid='floor-input'
                labelText={<>Piso {address.isBuilding && <span className='mandatory'>*</span>}</>}
                iconPosition='trailing-icon'
                status={value ? 'success' : 'default'}
                maxLength={15}
              >
                {value ? <CheckCircle size={21} /> : <></>}
              </NumericInput>
            )}
          />
        </div>
        <div className='addressValidation-inputWrapper'>
          <Controller
            name='apartment'
            defaultValue=''
            control={control}
            rules={{ required: { value: address.isBuilding, message: 'Obligatorio' } }}
            render={({ field: { name, onChange, ref, value, disabled } }) => (
              <AlphanumericInput
                id='apartment'
                name={name}
                onChange={onChange}
                ref={ref}
                value={value}
                disabled={disabled}
                typeInput='text'
                data-testid='apartment-input'
                labelText={
                  <>Departamento {address.isBuilding && <span className='mandatory'>*</span>}</>
                }
                iconPosition='trailing-icon'
                status={value ? 'success' : 'default'}
                maxLength={15}
              >
                {value ? <CheckCircle size={21} /> : <></>}
              </AlphanumericInput>
            )}
          />
        </div>
        <div className='addressValidation-inputWrapper'>
          <Controller
            name='tower'
            defaultValue=''
            control={control}
            render={({ field: { name, onChange, ref, value } }) => (
              <Input
                id='tower'
                name={name}
                onChange={onChange}
                ref={ref}
                value={value}
                typeInput='text'
                labelText='Torre'
                iconPosition='trailing-icon'
                status={value ? 'success' : 'default'}
                data-testid='tower-input'
                maxLength={15}
              >
                {value ? <CheckCircle size={21} /> : <></>}
              </Input>
            )}
          />
        </div>
        <div className='addressValidation-inputWrapper'>
          <Controller
            name='additionalNotes'
            defaultValue=''
            control={control}
            render={({ field: { name, onChange, ref, value, disabled } }) => (
              <AlphanumericInput
                id='additionalNotes'
                name={name}
                onChange={onChange}
                ref={ref}
                value={value}
                disabled={disabled}
                typeInput='text'
                labelText='Aclaraciones adicionales'
                iconPosition='trailing-icon'
                status={value ? 'success' : 'default'}
                data-testid='additionalNotes-input'
                maxLength={70}
              >
                {value ? <CheckCircle size={21} /> : <></>}
              </AlphanumericInput>
            )}
          />
        </div>
        <Button
          className='submit-button-error'
          type='submit'
          disabled={!isValid}
          data-testid='addressValidation-continue-button'
        >
          {text.button}
        </Button>
      </form>
    </section>
  );
};

export default AddressValidation;
